import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useInitAtom } from '~/lib/jotai'
import type { Area, AreaMain } from './data/type'

const area$ = atom<Area | undefined>(undefined)
area$.debugLabel = 'area$'

export function useArea() {
  return useAtomValue(area$)
}

const selectedArea$ = atom<string | undefined>(undefined)
selectedArea$.debugLabel = 'selectedArea$'

export function useSelectedArea() {
  return useAtomValue(selectedArea$)
}

export function useSetSelectedArea() {
  return useSetAtom(selectedArea$)
}

export function useHydrateArea(area: Area) {
  useInitAtom(area$, area)
}

export function useHydrateSelectedArea(code?: string) {
  useInitAtom(selectedArea$, initSelectedArea(code))
}

const popularAreas = [
  '03001', // 東京
  '03002', // 神奈川
  '03004', // 千葉
  '07001', // 大阪
  '07002', // 京都
  '07003', // 兵庫
  '06001', // 奈良
]

export function initSelectedArea(code?: string) {
  // 何も指定がない場合は東京にする
  // res2に準拠し人気のエリアに含まれていない都道府県が指定された場合は東京にする
  return code === undefined ? '03001' : popularAreas.includes(code) ? code : '03001'
}
if (import.meta.vitest) {
  const { it, describe, expect } = import.meta.vitest
  describe('initSelectedArea', () => {
    it('指定なしの場合は東京がデフォルト値', () => {
      expect(initSelectedArea()).toBe('03001')
    })
    it('人気のエリアに含まれている都道府県を指定している場合は、該当都道府県がデフォルト値', () => {
      expect(initSelectedArea('03001')).toBe('03001')
      expect(initSelectedArea('03002')).toBe('03002')
      expect(initSelectedArea('03004')).toBe('03004')
      expect(initSelectedArea('07001')).toBe('07001')
      expect(initSelectedArea('07002')).toBe('07002')
      expect(initSelectedArea('07003')).toBe('07003')
      expect(initSelectedArea('06001')).toBe('06001')
    })
    it('人気のエリアに含まれない都道府県を指定している場合は、東京がデフォルト値', () => {
      expect(initSelectedArea('03003')).toBe('03001')
    })
  })
}

const areaMain$ = atom<AreaMain[] | undefined>((get) => {
  const area = get(area$)
  if (area === undefined) {
    return undefined
  }
  return area.main
})
areaMain$.debugLabel = 'areaMain$'

export function useAreaMain() {
  return useAtomValue(areaMain$)
}

const selectedAreaMain$ = atom<AreaMain | undefined>((get) => {
  const selected = get(selectedArea$)
  const area = get(areaMain$)
  if (area === undefined) {
    return undefined
  }
  return area.find((m) => m.code === selected)
})
selectedAreaMain$.debugLabel = 'selectedAreaMain$'

export function useSelectedAreaMain() {
  return useAtomValue(selectedAreaMain$)
}
